import React, { useState } from 'react';

import { Navigate } from 'react-router-dom';

import useFilters from '../hooks/useFilters';

import { StyledPaginatedArticleList } from '../components/ArticleList/PaginatedArticleList.styled';

const withPagination =
  (WrappedComponent) =>
  ({ data, ...props }) => {
    const { pagination } = useFilters();
    const [currPage, setCurrPage] = useState(1);

    const totalPages = Math.ceil(data?.length / pagination);
    const paginatedData = data?.slice(
      (currPage - 1) * pagination,
      currPage * pagination
    );

    return data ? (
      <StyledPaginatedArticleList>
        <WrappedComponent data={paginatedData} {...props} />
        <div>
          <button
            onClick={() => setCurrPage((p) => p - 1)}
            disabled={currPage === 1}
          >
            Prev
          </button>
          <span>
            {currPage} / {totalPages}
          </span>
          <button
            onClick={() => setCurrPage((p) => p + 1)}
            disabled={currPage === totalPages}
          >
            Next
          </button>
        </div>
      </StyledPaginatedArticleList>
    ) : (
      <Navigate to={'/error'} />
    );
  };

export default withPagination;
